"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
class ErrorBoundary extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {});
  }
  static getDerivedStateFromError(error) {
    return {
      error,
      hasError: true
    };
  }
  render() {
    const {
      error
    } = this.state;
    const {
      fallback
    } = this.props;
    if (error) {
      // We display full error to console instead of just showing message to user
      // eslint-disable-next-line no-console -- Error boundary may log errors.
      console.error(error);
      return fallback ?? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          children: "Sorry, something went wrong!"
        })
      });
    }
    const {
      children
    } = this.props;
    return children;
  }
}
exports.ErrorBoundary = ErrorBoundary;
